import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import {elementCheckVisibility, elementCheckVisuallyHidden} from "../../Utility/Utility";
import {SectionAmount} from "../SectionAmount/SectionAmount";
import {SectionGiftAid} from "../SectionGiftAid/SectionGiftAid";
import {SectionBankDetails} from "../SectionBankDetails/SectionBankDetails";
import {SectionBillingAddress} from "../SectionBillingAddress/SectionBillingAddress";
import {SectionCardDetails} from "../SectionCardDetails/SectionCardDetails";
import {SectionInMemory} from "../SectionInMemory/SectionInMemory";
import {SectionOptins} from "../SectionOptins/SectionOptins";
import {SectionOrganisationDetails} from "../SectionOrganisationDetails/SectionOrganisationDetails";
import {SectionPersonalDetails} from "../SectionPersonalDetails/SectionPersonalDetails";
import {SectionQuickPay} from "../SectionQuickPay/SectionQuickPay";
import {SectionReasonForDonating} from "../SectionReasonForDonating/SectionReasonForDonating";
import {SectionCustomFields} from "../SectionCustomFields/SectionCustomFields";
import {SectionRecipientDetails} from "../SectionRecipientDetails/SectionRecipientDetails";
import {SectionAddress} from "../SectionAddress/SectionAddress";
import {SectionSpacer} from "../SectionSpacer/SectionSpacer";
import {PaymentStateManager} from "../../Utility/PaymentStateManager";

const SectionTypes = {
  SectionAmount             : SectionAmount,
  SectionGiftAid            : SectionGiftAid,
  SectionBankDetails        : SectionBankDetails,
  SectionBillingAddress     : SectionBillingAddress,
  SectionCardDetails        : SectionCardDetails,
  SectionInMemory           : SectionInMemory,
  SectionOptins             : SectionOptins,
  SectionOrganisationDetails: SectionOrganisationDetails,
  SectionPersonalDetails    : SectionPersonalDetails,
  SectionQuickPay           : SectionQuickPay,
  SectionReasonForDonating  : SectionReasonForDonating,
  SectionCustomFields       : SectionCustomFields,
  SectionRecipientDetails   : SectionRecipientDetails,
  SectionAddress            : SectionAddress,
  SectionSpacer             : SectionSpacer,
}

/**
 * Primary UI component for user interaction
 */
export const SectionFieldGroup = forwardRef(({fields, name, itemIndex, loqateKey, stateManager, staticText, validationHash, values}, ref) => {
  const refs = fields.map(() => useRef())
  const [_, stateRefresh] = useState(Date.now())

  /**
   * Handle the child input change.
   *
   * @param {string} name
   *   The name of the state to update
   * @param {string|boolean|{}|number} value
   *   The value to update.
   */
  const childInputChange = (name, value) => {
    if (typeof itemIndex !== 'undefined') {
      stateManager.orderItemAtIndexUpdate(itemIndex, name, value)
    }

    stateRefresh(Date.now())
  }

  /**
   * Checks if th child elements are valid
   *
   * @returns {boolean}
   */
  const isValid = () => {
    return refs.reduce((isValid, ref) => {
      return ref.current && ref.current['isValid'] ? ref.current['isValid']() ? isValid : false : isValid
    }, true)
  }

  useImperativeHandle(ref, () => ({
    isValid: () => isValid(),
  }))

  /**
   * The local values for the child fields.
   *
   * @type {{}}
   */
  const localValues = stateManager.orderItemAtIndexGet(itemIndex)

  console.log("localValues", localValues)

  return (
    <>
      {fields.map((section, key) => {
        return (
          (typeof SectionTypes[section.type] !== 'undefined') && elementCheckVisibility(section, values) ?
            React.createElement(SectionTypes[section.type], {
              ...section,
              onInputChange : childInputChange,
              ref           : refs[key],
              values        : localValues,
              staticText    : staticText,
              key           : key,
              validationHash: validationHash,
              loqateKey     : loqateKey,
              visuallyHidden: elementCheckVisuallyHidden(section, localValues)
            }) : null
        )
      })}
    </>
  )
})

SectionFieldGroup.propTypes = {
  stateManager  : PropTypes.instanceOf(PaymentStateManager),
  name          : PropTypes.string,
  itemIndex     : PropTypes.number,
  loqateKey     : PropTypes.string,
  fields        : PropTypes.array,
  staticText    : PropTypes.object,
  values        : PropTypes.object,
  validationHash: PropTypes.string,
}

